export const BLINQ_PRIVACY_POLICY = 'https://blinq.me/legal/privacy-policy';
export const BLINQ_TERMS_AND_CONDITIONS = 'https://blinq.me/legal/terms-conditions';
export const BLINQ_TERMS_OF_USE = 'https://blinq.me/legal/website-terms-of-use';
export const BLINQ_HUBSPOT_ONBOARDING = 'https://meetings.hubspot.com/blinq-growth/onboarding';
export const BLINQ_SUPPORT = 'https://support.blinq.me/hc/en-us';
